<template>
  <div class="dataview-custom-target">
    <i class="cicon-error_filled" @click="onDel"></i>
    <c-tooltip :content="config.name">
      <div class="custom-item-title">
        {{ config.name }}
      </div>
    </c-tooltip>
    <template v-if="store">
      <div class="custom-item-value">
        <span
          class="no-revenue"
          v-if="config.type === 'totalRevenue' && !revenue"
        >
          0<span class="revenue-tip">需接入收入数据</span>
        </span>
        <template v-else>
          <number-board :val="store.count" v-if="store.count"></number-board>
          <template v-else>
            0
          </template>
          <span class="unit">{{ unit }}</span>
        </template>
      </div>
      <div
        v-if="revenue || config.type !== 'totalRevenue'"
        class="custom-huanbi"
        :style="{
          color:
            store.huanbi === '-' || !store.huanbi
              ? 'none'
              : /^-/.test(store.huanbi)
              ? '#29bd76'
              : '#f55858'
        }"
      >
        <span ref="bottom1">
          <label>环比: </label>
          <c-tooltip :content="huanbiTip">
            <template v-if="store.huanbi === '-' || !store.huanbi">
              -
            </template>
            <template v-else>
              <i
                :class="
                  /^-/.test(store.huanbi)
                    ? 'icon-arrow_glyph_down'
                    : 'icon-arrow_glyph_up'
                "
              ></i>
              {{ store.huanbi.replace('-', '') }}%
            </template>
          </c-tooltip>
        </span>
      </div>
      <div
        class="custom-tongbi"
        v-if="revenue || config.type !== 'totalRevenue'"
        :style="{
          color:
            !store.tongbi || store.tongbi === '-'
              ? 'none'
              : /^-/.test(store.tongbi)
              ? '#29bd76'
              : '#f55858'
        }"
      >
        <span ref="bottom2">
          <label>同比: </label>
          <c-tooltip :content="tongbiTip">
            <template v-if="!store.tongbi || store.tongbi === '-'">-</template>
            <template v-else>
              <i
                :class="
                  /^-/.test(store.tongbi)
                    ? 'icon-arrow_glyph_down'
                    : 'icon-arrow_glyph_up'
                "
              ></i>
              {{ store.tongbi.replace('-', '') }}%
            </template>
          </c-tooltip>
        </span>
      </div>
    </template>
    <c-loading v-if="loading || !store" tip=""></c-loading>
  </div>
</template>
<script>
import { actions } from '../../store/constants'
import NumberBoard from '../../components/numberBoard'
import { util } from '../../utils'
import { mapState } from 'vuex'
export default {
  name: 'DataviewCustomTarget',
  components: {
    NumberBoard
  },
  props: {
    addMode: {
      type: Boolean,
      default: false
    },
    config: null,
    /**
     * {
          count: 0,
          tongbi: '',
          huanbi: ''
        }
     */
    store: {
      type: Object
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState({
      revenue (state) {
        let revenue = null
        state.bizSys.eventList.forEach(event => {
          if (event.event_name === 'revenue' && event.owner === 'zg_abp') {
            revenue = event
          }
        })
        return revenue
      }
    }),
    huanbiTip () {
      const today = new Date()
      const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000)
      const value = this.store.huanbi
      return `截止到今天${today.getHours()}点, ${util.dateFormat(
        today,
        'mm月dd日'
      )}和${util.dateFormat(yesterday, 'mm月dd日')}对比${
        /^-/.test(value) ? '下降' : '上升'
      }了${value.replace('-', '') || '-'}%`
    },
    tongbiTip () {
      let value = this.store.tongbi
      let date = new Date(new Date().getTime() - this.$util.dayTime * 7)
      let today = new Date()
      return `截止到今天${today.getHours()}点, ${this.$util.dateFormat(
        today,
        'mm月dd日'
      )}和${this.$util.dateFormat(date, 'mm月dd日')}对比${
        /^-/.test(value) ? '下降' : '上升'
      }了${value.replace('-', '') || '-'}%`
    },
    unit () {
      const map = {
        users: '人',
        times: '次',
        pv: '次'
      }
      return map[this.config.type]
    }
  },
  watch: {
    store () {
      this.$nextTick(() => {
        const eles = [this.$refs.bottom1, this.$refs.bottom2]
        let maxWidth = 0
        eles.forEach(ele => {
          if (ele) maxWidth = Math.max(ele.offsetWidth, maxWidth)
        })
        eles.forEach(ele => {
          if (ele) ele.style.width = `${maxWidth}px`
        })
      })
    }
  },
  methods: {
    onDel () {
      this.loading = true
      this.$store
        .dispatch(actions.dataview.delConfig, this.config.id)
        .then(() => {
          this.$emit('afterDel')
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: '删除指标失败'
          })
          console.error('删除自定义指标失败', err)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="sass">
@import './styles/target'
</style>
